import React, { useState } from 'react';
import { toast } from 'react-toastify';

import Grid from '@material-ui/core/Grid';

import { Button, Dialog, Text } from 'components';
import { Field, Form, Formik } from 'formik';
import { launchPrivider } from 'services';
import * as Yup from 'yup';

const validationSchema = Yup.object().shape({
  client: Yup.string().required('O nome do cliente é obrigatório'),
});

export const DialogEditClient = ({ open, onClose, line }) => {
  if (!open) return null;
  const [isLoading, setIsLoading] = useState(false);

  const toInputUppercase = (e) => {
    e.target.value = ('' + e.target.value).toUpperCase().trim();
  };

  const onSubmit = async (values) => {
    setIsLoading(true);
    try {
      await launchPrivider.updateClientLaunch({
        id_client: line?.idCadastro,
        name_client: values.client,
      });
      toast.success('Cliente editado com sucesso!');
      onClose();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Erro ao editar cliente');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Dialog open={open}>
      <Dialog.Title onClose={onClose}>Editar Cliente</Dialog.Title>
      <Formik
        initialValues={{ client: line?.cliente }}
        onSubmit={onSubmit}
        validationSchema={validationSchema}
      >
        <Form>
          <Dialog.Content>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Field
                  label='Nome Cliente'
                  variant='outlined'
                  name='client'
                  size='small'
                  component={Text}
                  onInput={toInputUppercase}
                />
              </Grid>
            </Grid>
          </Dialog.Content>
          <Dialog.Actions>
            <Button fullWidth color='secondary' onClick={onClose} loading={isLoading}>
              Cancelar
            </Button>
            <Button fullWidth loading={isLoading} type='submit'>
              Salvar
            </Button>
          </Dialog.Actions>
        </Form>
      </Formik>
    </Dialog>
  );
};
